import { Role } from "@/enum";
import { SORT_BY_ALL } from "@/pages/Private/pages/ToDo/ManageToDos/components/SortDropDown";
import { ShowingMode } from "@/pages/Private/pages/ToDo/ToDoList/enum/ShowingMode.enum";
import { StatisticType } from "@/pages/Private/pages/ToDo/ToDoList/enum/StatisticType.enum";
import { ToDoPriority } from "@/pages/Private/pages/ToDo/ToDoList/enum/ToDoPriority.enum";
import { ToDoStatus } from "@/pages/Private/pages/ToDo/ToDoList/enum/ToDoStatus.enum";
import { QuestionnaireImportance } from "@/pages/Public/pages/Questionnaire/enum/QuestionnaireImportance.enum";

export default {
	translation: {
		marketing: {
			nav: {
				product: "Produkt",
				pricing: "Preise",
				about: "Über uns",
				contact: "Kontakt",
				login: "Login",
				startCheck: "Kostenlosen Schnellcheck starten",
				menu: "Menü öffnen",
			},
			footer: {
				product: "Produkt",
				pricing: "Preise",
				quickCheck: "Schnellcheck",
				about: "Über uns",
				contact: "Kontakt",
			},
			product: {
				title: "Die Plattform, mit der der Mittelstand NIS-2 umsetzt",
				subtitle:
					"NIS360 verwandelt die NIS-2-Anforderungen in einen konkreten Maßnahmenplan für Ihr Unternehmen: priorisierte Aufgaben, klare Verantwortlichkeiten, messbarer Fortschritt und auditfeste Nachweise.",
				modules: [
					{
						kicker: "Betroffenheits- & GAP-Analyse",
						title: "Wissen, wo Sie stehen – in Minuten statt Wochen",
						description:
							"Der geführte Check ermittelt Ihre Betroffenheit und Ihre Lücken gemäß BSIG. Das Ergebnis ist keine Broschüre, sondern Ihr individueller Maßnahmenplan – die Arbeitsgrundlage für Ihre gesamte Umsetzung.",
					},
					{
						kicker: "Maßnahmenplan & Aufgaben-Board",
						title: "Aus Anforderungen werden Aufgaben, aus Aufgaben wird Fortschritt",
						description:
							"30+ priorisierte Maßnahmen mit Umsetzungsanleitungen, organisiert im Kanban-Board mit Review-Workflow. Jeder weiß, was zu tun ist – und Sie sehen jederzeit, wo Sie stehen.",
					},
					{
						kicker: "Team & Rollen",
						title: "Compliance ist Teamarbeit – NIS360 macht sie organisierbar",
						description:
							"Laden Sie IT, Geschäftsführung und Datenschutz mit eigenen Rollen und Rechten ein. Verantwortlichkeiten sind klar geregelt – ohne lange E-Mail-Verläufe und Excel-Listen.",
					},
					{
						kicker: "KI-Assistent",
						title: "Fragen zur Umsetzung? Sofort beantwortet – im Kontext Ihrer Aufgabe",
						description:
							"Der NIS-2-Assistent beantwortet Fragen direkt in der jeweiligen Aufgabe – trainiert auf BSIG, BSI-Grundschutz und ISO 27001.",
					},
				],
				extraModulesTitle: "Außerdem in NIS360",
				extraModules: [
					{
						title: "Fortschritts-Tracking",
						description:
							"Messbarer Umsetzungsstand auf einen Blick: offene, laufende und erledigte Maßnahmen – ideal für Berichte an die Geschäftsführung.",
					},
					{
						title: "PDF-Reports & Audit-Nachweise",
						description:
							"Auditfeste Dokumentation Ihrer Umsetzung als PDF – für Behörde, Prüfer und interne Gremien.",
					},
					{
						title: "Lieferketten-Risikobewertung",
						description:
							"Bewerten Sie Risiken bei Dienstleistern und Zulieferern systematisch und erfüllen Sie die NIS-2-Anforderungen an die Lieferkettensicherheit.",
					},
				],
				ctaTitle: "Überzeugen Sie sich selbst – kostenlos und unverbindlich",
				ctaDescription:
					"Starten Sie mit dem 3-Minuten-Schnellcheck und erhalten Sie Ihren individuellen Maßnahmenplan – oder lassen Sie sich die Plattform persönlich zeigen.",
				ctaCheckButton: "Kostenlosen Schnellcheck starten",
				ctaDemoButton: "Demo vereinbaren",
			},
			pricing: {
				title: "Preise & Pläne",
				subtitle:
					"Starten Sie kostenlos mit dem Schnellcheck – und erweitern Sie auf die volle Plattform, wenn Sie bereit sind. Für komplexe Anforderungen kombinieren Sie NIS360 mit der Beratung der MACONIA GmbH.",
				highlightBadge: "Empfohlen",
				plans: [
					{
						name: "Schnellcheck",
						price: "Kostenlos",
						priceNote: "",
						description:
							"Der risikofreie erste Schritt: Finden Sie heraus, wo Ihr Unternehmen steht.",
						features: [
							"Betroffenheitsanalyse nach BSIG",
							"GAP-Überblick über Ihre Lücken",
							"Persönlicher Maßnahmenüberblick als PDF",
							"Ohne Registrierung startbar",
						],
						cta: "Jetzt prüfen",
					},
					{
						name: "NIS360 Professional",
						price: "Auf Anfrage",
						priceNote: "",
						description: "Die komplette Plattform für Ihre strukturierte NIS-2-Umsetzung.",
						features: [
							"Vollständiger Maßnahmenplan (30+ Aufgaben)",
							"Aufgaben-Board mit Review-Workflow",
							"Team-Kollaboration mit Rollen & Rechten",
							"KI-Assistent (BSIG, BSI-Grundschutz, ISO 27001)",
							"Auditfeste PDF-Reports & Nachweise",
						],
						cta: "Demo vereinbaren",
						highlighted: true,
					},
					{
						name: "NIS360 + Beratung",
						price: "Individuell",
						priceNote: "",
						description:
							"Plattform plus persönliche Begleitung durch die IT-Sicherheitsexperten der MACONIA GmbH.",
						features: [
							"Vollzugriff NIS360 Professional",
							"Persönliche Beratung & Workshops",
							"Audit-Begleitung durch Experten",
							"Unterstützung bei Richtlinien & Prozessen",
						],
						cta: "Gespräch vereinbaren",
					},
				],
				footnote:
					"Alle Pläne basieren auf derselben Plattform – Sie starten mit dem kostenlosen Schnellcheck und behalten Ihre Ergebnisse beim Upgrade.",
			},
			quickCheck: {
				title: "Der kostenlose NIS-2-Schnellcheck",
				subtitle:
					"Finden Sie in 3 Minuten heraus, ob Ihr Unternehmen unter NIS-2 fällt und wo Ihre größten Lücken liegen. Am Ende wartet Ihr persönlicher Maßnahmenplan in der Plattform.",
				benefits: [
					"Sofortiges Ergebnis: Betroffenheit & GAP-Überblick",
					"Persönlicher Maßnahmenüberblick als PDF",
					"Ihr individueller Maßnahmenplan in der Plattform – als kostenloser nächster Schritt",
				],
				ctaButton: "Schnellcheck starten",
				stepsTitle: "So läuft der Check ab",
				steps: [
					{
						step: "Schritt 1",
						title: "Fragen beantworten",
						description:
							"Geführte Betroffenheits- und GAP-Analyse – verständlich formuliert, ohne Juristendeutsch.",
					},
					{
						step: "Schritt 2",
						title: "Sofortige Auswertung",
						description:
							"Sie sehen direkt, ob Ihr Unternehmen betroffen ist und wo Ihre Lücken liegen.",
					},
					{
						step: "Schritt 3",
						title: "Maßnahmenplan erhalten",
						description:
							"Ihr individueller Plan mit 30+ priorisierten Aufgaben wartet in der Plattform – die Registrierung ist kostenlos.",
					},
				],
				disclaimerTitle: "Was der Check nicht ist",
				disclaimerText:
					"Der Schnellcheck ist eine strukturierte Selbsteinschätzung und ersetzt keine Rechtsberatung. Er gibt Ihnen eine fundierte Orientierung auf Basis Ihrer Angaben.",
				privacyTitle: "Ihre Daten bleiben bei Ihnen",
				privacyText:
					"Der Check ist ohne Registrierung startbar. Ihre Antworten werden vertraulich behandelt und nicht an Dritte weitergegeben.",
				finalCtaTitle: "Wo steht Ihr Unternehmen? Finden Sie es jetzt heraus.",
			},
			about: {
				title: "Von Praktikern gebaut – nicht von einem anonymen SaaS",
				subtitle:
					"NIS360 wird von der MACONIA GmbH entwickelt – einem auf IT-Sicherheit spezialisierten Beratungsunternehmen mit über 10 Jahren Erfahrung im Mittelstand. Die Plattform bündelt das Wissen aus der Beratungspraxis.",
				values: [
					{
						title: "Beratungserfahrung im Produkt",
						description:
							"Über 10 Jahre IT-Sicherheitsberatung für mittelständische Unternehmen fließen direkt in die Maßnahmen, Anleitungen und Workflows von NIS360 ein.",
					},
					{
						title: "Anerkannte Standards",
						description:
							"Beratung und Plattform orientieren sich an BSI-Grundschutz, ISO 27001 und den EU-Vorgaben – damit Ihre Umsetzung vor Prüfern besteht.",
					},
					{
						title: "Partner statt Tool-Anbieter",
						description:
							"Wenn Software nicht reicht, sind unsere Berater da: von Workshops über Richtlinienarbeit bis zur Audit-Begleitung.",
					},
				],
				certificationsTitle: "Zertifizierungen & Standards",
				certificationsText:
					"Unsere Arbeit orientiert sich an etablierten Standards und Zertifizierungen der IT-Sicherheitsbranche.",
				consultingTitle: "Mehr als Software: Beratung, wenn Sie sie brauchen",
				consultingText:
					"Ob Audit-Begleitung, Workshops oder individuelle Sicherheitskonzepte – die Experten hinter NIS360 unterstützen Sie persönlich.",
				consultingCta: "Gespräch vereinbaren",
			},
			contact: {
				title: "Kontakt & Demo",
				subtitle:
					"Sie möchten NIS360 live sehen, haben Fragen zur Plattform oder zur NIS-2-Umsetzung? Schreiben Sie uns – wir melden uns innerhalb eines Werktags.",
			},
			privacy: {
				title: "Datenschutzerklärung",
				lastUpdated: "Stand: Juni 2026",
				intro:
					"Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. In dieser Datenschutzerklärung informieren wir Sie gemäß der EU-Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG) darüber, welche personenbezogenen Daten wir im Rahmen der Plattform NIS360 (nis360.de) erheben, zu welchen Zwecken wir sie verarbeiten und welche Rechte Ihnen zustehen.",
				sections: [
					{
						heading: "1. Verantwortlicher",
						paragraphs: [
							"Verantwortlicher im Sinne der DSGVO und sonstiger datenschutzrechtlicher Bestimmungen ist:",
							"MACONIA GmbH\nHolger Könnecke\nKurfürstendamm 11\n10719 Berlin\nDeutschland",
							"Vertretungsberechtigte Person: Holger Könnecke\nHandelsregister: HRB 211946 B, Amtsgericht Berlin\nE-Mail: datenschutz@maconia.de\nImpressum: www.maconia.de/impressum",
							"Für alle Fragen und Anliegen zum Datenschutz sowie zur Ausübung Ihrer Rechte erreichen Sie uns unter datenschutz@maconia.de.",
						],
					},
					{
						heading: "2. Allgemeines zur Datenverarbeitung und Rechtsgrundlagen",
						paragraphs: [
							"Wir verarbeiten personenbezogene Daten unserer Nutzerinnen und Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Plattform sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung oder auf Grundlage einer gesetzlichen Erlaubnis.",
							"Soweit wir für Verarbeitungsvorgänge eine Einwilligung einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage. Bei der Verarbeitung zur Erfüllung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen ist Art. 6 Abs. 1 lit. b DSGVO die Rechtsgrundlage. Soweit eine Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, dient Art. 6 Abs. 1 lit. c DSGVO als Grundlage. Ist die Verarbeitung zur Wahrung berechtigter Interessen unsererseits oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten der betroffenen Person das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage.",
							"Personenbezogene Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine darüber hinausgehende Speicherung erfolgt nur, wenn dies durch gesetzliche Aufbewahrungspflichten vorgesehen ist.",
						],
					},
					{
						heading: "3. Hosting und Server-Logfiles",
						paragraphs: [
							"Wir hosten unsere Plattform bei der Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Deutschland. Die Server befinden sich in Rechenzentren innerhalb der Europäischen Union. Mit Hetzner besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
							"Bei jedem Aufruf unserer Plattform erfasst das System automatisiert Daten und Informationen des aufrufenden Geräts. Hierzu zählen insbesondere die IP-Adresse, Datum und Uhrzeit des Zugriffs, die aufgerufene Seite bzw. Datei, die zuvor besuchte Seite (Referrer), der verwendete Browsertyp und dessen Version sowie das Betriebssystem.",
							"Diese Daten werden in den Logfiles unseres Systems gespeichert. Die Verarbeitung dient der Auslieferung der Inhalte, der Gewährleistung der Systemsicherheit und -stabilität sowie der technischen Administration. Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren und störungsfreien Betrieb gemäß Art. 6 Abs. 1 lit. f DSGVO. Die Logfiles werden nach Zweckerfüllung bzw. spätestens nach einem gesetzlich bzw. organisatorisch festgelegten Zeitraum gelöscht.",
						],
					},
					{
						heading: "4. Cookies und lokale Speicherung",
						paragraphs: [
							"Wir setzen keine Tracking- oder Marketing-Cookies und keine Cookies von Drittanbietern zu Werbezwecken ein. Wir verwenden ausschließlich technisch notwendige Speichermechanismen im lokalen Speicher (Local Storage) Ihres Browsers.",
							"Konkret speichern wir nach Anmeldung ein Authentifizierungs-Token (JSON Web Token), um Sie während Ihrer Sitzung angemeldet zu halten, sowie Ihre gewählte Spracheinstellung (Schlüssel i18nextLng). Diese Daten verbleiben in Ihrem Browser und werden nicht zu Analyse- oder Werbezwecken ausgewertet.",
							"Rechtsgrundlage für den Einsatz dieser unbedingt erforderlichen Speichermechanismen ist § 25 Abs. 2 TDDDG (vormals TTDSG) in Verbindung mit unserem berechtigten Interesse an einer funktionsfähigen und sicheren Bereitstellung der Plattform gemäß Art. 6 Abs. 1 lit. f DSGVO. Eine Einwilligung ist hierfür nicht erforderlich. Sie können Ihren Browser so einstellen, dass diese Speicherung verhindert wird; in diesem Fall stehen Ihnen die Anmelde- und Sprachfunktionen jedoch möglicherweise nicht zur Verfügung.",
						],
					},
					{
						heading: "5. Registrierung und Nutzerkonto",
						paragraphs: [
							"Wenn Sie ein Nutzerkonto anlegen, verarbeiten wir die von Ihnen angegebenen Daten. Dazu gehören insbesondere Ihr Vor- und Nachname, Ihre E-Mail-Adresse, Angaben zu Ihrem Unternehmen sowie Ihr Passwort. Passwörter werden ausschließlich verschlüsselt (gehasht mit dem bcrypt-Verfahren) gespeichert und sind für uns zu keinem Zeitpunkt im Klartext einsehbar.",
							"Die Verarbeitung erfolgt zur Bereitstellung des Nutzerkontos und der vertraglich vereinbarten Funktionen sowie zur Verwaltung der Plattform-Nutzung. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. Durchführung vorvertraglicher Maßnahmen).",
							"Im Rahmen der Zusammenarbeit in Teams können von Ihnen erstellte Inhalte wie Aufgaben, Kommentare und Statusänderungen für berechtigte Mitglieder Ihres Unternehmens sichtbar sein. Über Aktivitäten in Ihrem Konto informieren wir Sie zudem per Benachrichtigung und E-Mail.",
							"Wir verwenden ein Authentifizierungsverfahren auf Basis von Token sowie optional eine Zwei-Faktor-Authentifizierung (2FA), um den Zugang zu Ihrem Konto abzusichern. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b und lit. f DSGVO.",
						],
					},
					{
						heading: "6. NIS-2-Schnellcheck und Fragebogen",
						paragraphs: [
							"Über den NIS-2-Schnellcheck und weiterführende Fragebögen erheben wir Angaben zu Ihrem Unternehmen, etwa Branche, Unternehmensgröße, Umsatz- und Bilanzkennzahlen sowie Ihre Kontaktdaten. Diese Angaben dienen dazu, die NIS-2-Relevanz Ihres Unternehmens zu bewerten, einen individuellen Maßnahmenplan zu erstellen und Ihnen das Ergebnis bereitzustellen.",
							"Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher Maßnahmen und Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO hinsichtlich unseres berechtigten Interesses an der Bereitstellung und Weiterentwicklung unserer Leistungen.",
							"Sofern Sie uns über den Fragebogen oder das Kontaktformular Ihre Kontaktdaten übermitteln, können diese zur Nachverfolgung Ihrer Anfrage an unser Kundenbeziehungs-Management (siehe Abschnitt HubSpot) übermittelt werden.",
						],
					},
					{
						heading: "7. Kontaktformular und Kontaktaufnahme",
						paragraphs: [
							"Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, verarbeiten wir die von Ihnen übermittelten Daten – insbesondere Ihren Namen, Ihre E-Mail-Adresse und den Inhalt Ihrer Nachricht – zur Bearbeitung Ihrer Anfrage.",
							"Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage auf den Abschluss oder die Durchführung eines Vertrags gerichtet ist, im Übrigen Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an der Beantwortung von Anfragen. Die Daten werden gelöscht, sobald sie für die Erreichung des Zwecks ihrer Erhebung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
						],
					},
					{
						heading: "8. Versand von E-Mails (Mailjet)",
						paragraphs: [
							"Für den Versand von Transaktions- und Benachrichtigungs-E-Mails (z. B. Registrierungsbestätigungen, Passwort-Zurücksetzungen, Aufgaben-Benachrichtigungen und Antworten auf Kontaktanfragen) nutzen wir den Dienst Mailjet der Mailjet SAS (Teil der Sinch-Gruppe), 13-13 bis Rue de l'Aubrac, 75012 Paris, Frankreich.",
							"Hierbei werden Ihre E-Mail-Adresse sowie die für den jeweiligen Versand erforderlichen Inhalte verarbeitet. Mailjet verarbeitet die Daten auf Servern innerhalb der Europäischen Union. Mit dem Anbieter besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
							"Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer zuverlässigen E-Mail-Kommunikation).",
						],
					},
					{
						heading: "9. Kundenbeziehungs-Management (HubSpot)",
						paragraphs: [
							"Zur Verwaltung von Anfragen und Interessenten sowie zur Pflege unserer Geschäftskontakte setzen wir das CRM-System HubSpot ein. Anbieter ist die HubSpot, Inc., 2 Canal Park, Cambridge, MA 02141, USA, in der EU vertreten durch die HubSpot Ireland Limited, Ground Floor, Two Dockland Central, Guild Street, Dublin 1, Irland.",
							"Im Rahmen der Nutzung übermitteln wir Kontakt- und Unternehmensdaten (insbesondere Name, E-Mail-Adresse und Angaben zum Unternehmen) an HubSpot, um Anfragen nachzuverfolgen und zu bearbeiten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer effizienten Kontakt- und Interessentenverwaltung) bzw. Art. 6 Abs. 1 lit. a DSGVO, soweit Sie eingewilligt haben.",
							"Eine Verarbeitung kann auch auf Servern in den USA erfolgen. Die Übermittlung in die USA ist durch den Abschluss von EU-Standardvertragsklauseln gemäß Art. 46 DSGVO abgesichert; soweit der Anbieter unter dem EU-US Data Privacy Framework zertifiziert ist, stützt sich die Übermittlung zusätzlich auf den Angemessenheitsbeschluss der EU-Kommission. Mit dem Anbieter besteht ein Vertrag zur Auftragsverarbeitung.",
						],
					},
					{
						heading: "10. KI-Assistent (OpenAI)",
						paragraphs: [
							"NIS360 stellt einen KI-gestützten Assistenten bereit, der Sie bei der Umsetzung von Maßnahmen unterstützt und Fragen zu Aufgaben beantwortet. Zur Bereitstellung dieser Funktion nutzen wir die Programmierschnittstelle (API) der OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA.",
							"Wenn Sie den KI-Assistenten nutzen, werden Ihre Eingaben (Chat-Nachrichten) sowie der jeweilige Kontext der Aufgabe und – sofern Sie Dokumente hochladen – deren Inhalte an OpenAI übermittelt und verarbeitet, um eine Antwort zu generieren. Nach Angaben von OpenAI werden über die API übermittelte Daten nicht zum Training der Modelle verwendet.",
							"Bitte geben Sie in den KI-Assistenten keine personenbezogenen oder sensiblen Daten ein, die für die jeweilige Anfrage nicht erforderlich sind. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Bereitstellung der vertraglich vereinbarten Funktion) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer leistungsfähigen Unterstützungsfunktion).",
							"Die Verarbeitung kann auf Servern in den USA erfolgen. Die Übermittlung ist durch EU-Standardvertragsklauseln gemäß Art. 46 DSGVO abgesichert. Mit OpenAI besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
						],
					},
					{
						heading: "11. Reichweitenmessung (Plausible Analytics)",
						paragraphs: [
							"Zur statistischen Auswertung der Nutzung unserer Plattform setzen wir Plausible Analytics ein, einen datenschutzfreundlichen Webanalysedienst der Plausible Insights OÜ, Västriku tn 2, Tartu, Estland. Die Datenverarbeitung erfolgt vollständig innerhalb der Europäischen Union.",
							"Plausible verwendet keine Cookies und speichert keine personenbezogenen Daten. Es werden keine geräteübergreifenden Profile gebildet. Erfasste Informationen wie aufgerufene Seiten, ungefähre Herkunft, verwendetes Gerät und Quelle des Zugriffs werden ausschließlich in aggregierter und anonymisierter Form ausgewertet; IP-Adressen werden nicht dauerhaft gespeichert und nicht zu identifizierenden Zwecken verwendet.",
							"Rechtsgrundlage ist unser berechtigtes Interesse an einer datensparsamen Analyse zur Verbesserung unseres Angebots gemäß Art. 6 Abs. 1 lit. f DSGVO.",
						],
					},
					{
						heading: "12. Dokumenten-Upload und KI-gestützte Verarbeitung",
						paragraphs: [
							"Sofern Sie im Rahmen der Plattform Dokumente hochladen, werden diese auf einem von uns betriebenen, EU-basierten Objektspeicher abgelegt. Zur Bereitstellung von KI-gestützten Funktionen können Dokumentinhalte in maschinenlesbare Vektoren (sogenannte Embeddings) umgewandelt und in einer von uns betriebenen Vektordatenbank gespeichert werden, um relevante Inhalte für den KI-Assistenten auffindbar zu machen.",
							"Die Verarbeitung dient ausschließlich der Bereitstellung der von Ihnen genutzten Funktionen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Zur Erzeugung der Embeddings kann der in Abschnitt 10 genannte Dienst (OpenAI) eingesetzt werden.",
						],
					},
					{
						heading: "13. Empfänger und Auftragsverarbeiter",
						paragraphs: [
							"Zur Erbringung unserer Leistungen setzen wir sorgfältig ausgewählte Dienstleister ein, die personenbezogene Daten in unserem Auftrag verarbeiten. Mit diesen Auftragsverarbeitern haben wir Verträge zur Auftragsverarbeitung gemäß Art. 28 DSGVO geschlossen.",
							"Dies sind insbesondere: Hetzner Online GmbH (Hosting, EU), Mailjet SAS (E-Mail-Versand, EU), HubSpot, Inc. (CRM, EU/USA) und OpenAI, L.L.C. (KI-Funktionen, USA). Eine Übermittlung an weitere Dritte findet nur statt, wenn dies gesetzlich zulässig oder zur Vertragserfüllung erforderlich ist oder Sie eingewilligt haben.",
						],
					},
					{
						heading: "14. Datenübermittlung in Drittländer",
						paragraphs: [
							"Eine Übermittlung personenbezogener Daten in Länder außerhalb der EU bzw. des EWR (insbesondere in die USA, im Zusammenhang mit OpenAI und HubSpot) erfolgt nur unter Einhaltung der gesetzlichen Anforderungen. Soweit kein Angemessenheitsbeschluss der EU-Kommission vorliegt, stützen wir die Übermittlung auf EU-Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO und gegebenenfalls ergänzende Schutzmaßnahmen. Soweit ein Anbieter unter dem EU-US Data Privacy Framework zertifiziert ist, stützt sich die Übermittlung zusätzlich auf den entsprechenden Angemessenheitsbeschluss.",
						],
					},
					{
						heading: "15. Speicherdauer und Löschung",
						paragraphs: [
							"Wir verarbeiten und speichern personenbezogene Daten nur so lange, wie es für die Erreichung der jeweiligen Verarbeitungszwecke erforderlich ist oder wie es durch gesetzliche Aufbewahrungsfristen (z. B. handels- und steuerrechtliche Pflichten) vorgegeben ist. Nach Wegfall des Zwecks und Ablauf etwaiger Aufbewahrungsfristen werden die Daten gelöscht oder gesperrt. Mit Löschung Ihres Nutzerkontos werden die zugehörigen Daten gelöscht, soweit keine Aufbewahrungspflichten entgegenstehen.",
						],
					},
					{
						heading: "16. Ihre Rechte als betroffene Person",
						paragraphs: [
							"Ihnen stehen gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten zu: das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie das Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO).",
							"Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an datenschutz@maconia.de.",
						],
					},
					{
						heading: "17. Widerruf von Einwilligungen",
						paragraphs: [
							"Soweit die Verarbeitung Ihrer Daten auf einer Einwilligung beruht, haben Sie das Recht, diese jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO). Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt davon unberührt.",
						],
					},
					{
						heading: "18. Beschwerderecht bei der Aufsichtsbehörde",
						paragraphs: [
							"Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden Daten gegen die DSGVO verstößt.",
							"Für uns zuständig ist: Berliner Beauftragte für Datenschutz und Informationsfreiheit, Alt-Moabit 59-61, 10555 Berlin. Sie können sich jedoch auch an die Aufsichtsbehörde Ihres üblichen Aufenthaltsorts oder Arbeitsplatzes wenden.",
						],
					},
					{
						heading: "19. Datensicherheit",
						paragraphs: [
							"Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten gegen Verlust, Zerstörung, Manipulation und unbefugten Zugriff zu schützen. Die Übertragung erfolgt verschlüsselt über TLS (Transport Layer Security). Passwörter werden ausschließlich als kryptografischer Hash gespeichert, und der Zugriff auf Daten ist durch Zugriffs- und Berechtigungskonzepte beschränkt. Unsere Maßnahmen werden entsprechend der technologischen Entwicklung fortlaufend angepasst.",
						],
					},
					{
						heading: "20. Änderungen dieser Datenschutzerklärung",
						paragraphs: [
							"Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt die jeweils aktuelle Fassung.",
						],
					},
				],
			},
		},
		"set-password": {
			secondTitle: "Setzen Sie Ihr Passwort",
			title: "Willkommen zurück {{name}}",
			description: "Ihre NIS-2-Compliance Roadmap ist bereit zum Download",
			confirm: "Bestätigen",
			pdfTitle: "NIS-2-Compliance Roadmap PDF",
			pdfSubtitle: "Ihre vollständige Aufgabenliste mit über 30 strukturierten Compliance-Aufgaben",
			pdfContent: "Inhalt der PDF:",
			pdfItemTasks: "Vollständige Aufgabenliste (30+ Aufgaben)",
			pdfItemDescriptions: "Detaillierte Beschreibungen und Anleitungen",
			pdfItemChecklists: "Compliance-Checklisten",
			downloadPdf: "PDF jetzt herunterladen",
			formDescription:
				"Erhalten Sie Zugriff auf NIS360-App und verwalten Sie Ihre Compliance-Aufgaben.",
			showPassword: "Passwort anzeigen",
			hidePassword: "Passwort verbergen",
			passwordMin8: "Das Passwort muss mindestens 8 Zeichen enthalten",
			passwordNumber: "Das Passwort muss mindestens 1 Zahl enthalten",
			passwordSpecial: "Das Passwort muss mindestens 1 Sonderzeichen enthalten",
			passwordUppercase: "Das Passwort muss mindestens 1 Großbuchstaben enthalten",
			passwordLowercase: "Das Passwort muss mindestens 1 Kleinbuchstaben enthalten",
		},
		aiChat: {
			toggle: "KI-Assistent",
			title: "NIS-2 KI-Assistent",
			clearHistory: "Verlauf löschen",
			loading: "Wird geladen...",
			emptyState: "Frag mich alles zur NIS-2-Konformität und zu dieser Aufgabe.",
			placeholder: "Frag zu NIS-2...",
		},
		createTask: {
			deleteTask: "Aufgabe löschen",
			deleteSubtask: "Unteraufgabe löschen",
			createTask: "Aufgabe erstellen",
			createSubtask: "Unteraufgabe erstellen",
			subtaskOf: "Unteraufgabe von",
			expandSubtasks: "Unteraufgaben einblenden",
			collapseSubtasks: "Unteraufgaben ausblenden",
			mainTitle: "Neue Aufgabe erstellen",
			title: "Titel",
			save: "Speichern",
			filterByAssignee: "Alle Abtretungsempfänger",
			description: "Beschreibung",
			assignee: "Zuständige Person",
			priority: "Priorität",
			status: "Status",
			complexity: "Komplexität",
			tags: "Tag",
			unassigned: "Nicht zugewiesen",
			low: "Niedrig",
			medium: "Mittel",
			high: "Hoch",

			"in-progress": "In Bearbeitung",
			done: "Erledigt",

			easy: "Einfach",
			normal: "Normal",
			hard: "Schwer",
			"very-hard": "Sehr schwer",

			validation: {
				"title-required": "Titel ist erforderlich",
			},
		},
		companies: {
			title: "Kunden",
			subtitle: "Verwalten Sie Ihre Teams und Benutzerberechtigungen.",
			search: "Nach Kunden suchen",
			"search-by-organization": "Nach Kunden suchen",
			"search-by-organization-description":
				"Sehen Sie sich eine Liste von Kunden und deren Teams an und verwalten Sie diese.",
			name: "Name",
			linkedinUrl: "LinkedIn URL",
			users: "Benutzer",
			website: "Website",
			create: {
				button: "Neuen Kunden hinzufügen",
			},
			delete: {
				title: "Diesen Kunden löschen?",
				description: 'Sind Sie sicher, dass Sie "{{companyName}}" löschen möchten?',
			},
			add: {
				title: "Neuen Kunden hinzufügen",
				subtitle:
					"Füllen Sie die erforderlichen Felder aus, um ein neues Unternehmen im System hinzuzufügen.",
			},
			edit: {
				title: "Kunden bearbeiten",
				subtitle: "Füllen Sie die erforderlichen Felder aus, um das Unternehmen zu bearbeiten.",
			},
		},
		company: {
			title: "Kunden",
			subtitle: "Verwalten Sie hier Ihre Teammitglieder und deren Kontoberechtigungen.",
			tabs: {
				general: "Allgemein",
				user: "Benutzer",
				roles: "Rollen",
			},
			companyInformation: "Firmeninformationen",
			autoInvite: "Autoeinladung zur Firmen Linkedin Page",
			apolloApiKey: "Apollo API Schlüssel",
			lemlistApiKey: "Lemlist API Schlüssel",
			"invite-company-members": "Teammitglieder einladen",
			"invite-company-members-description": "Laden Sie Ihre Kollegen zur Mitarbeit ein.",
			"add-another": "Weitere hinzufügen",
			"send-invite": "Einladung verschicken",
			"company-members": "Team",
			"company-member-description":
				"Verwalten Sie Ihr bestehendes Team und ändern Sie Rollen/Berechtigungen.",
		},
		dashboard: {
			title: "Willkommen",
		},
		questionnaire: {
			title: "Fragebogen",
			"select-industry": "Wählen Sie einen oder mehrere Sektoren aus ",
			"select-company-balance": "Wähle eine Jahresbilanz aus",
			landing: {
				title: "NIS-2 umsetzen. Strukturiert, nachweisbar, revisionsfest.",
				subtitle:
					"NIS360 erstellt Ihren individuellen Maßnahmenplan und führt Ihr Team von der Betroffenheitsanalyse bis zum auditfesten Nachweis – alles in einer Plattform.",
				ctaPrimary: "Kostenlos starten – mit dem 3-Minuten-Schnellcheck",
				ctaSecondary: "Plattform ansehen",
				ctaNote: "Kostenlos · ohne Registrierung startbar · sofortiges Ergebnis",
				yes: "Ja",
				no: "Nein",
				idk: "Betroffenheit prüfen",
				startCheck: "Schnellcheck starten",
			},
			landingThreeColumns: {
				kicker: "Typische Szenarien",
				title: "Kommt Ihnen das bekannt vor?",
				subtitle:
					"Drei Situationen, in denen Excel-Listen und Bauchgefühl nicht mehr reichen – und wie NIS360 sie löst.",
				problemLabel: "Das Problem",
				solutionLabel: "Die Lösung in NIS360",
				features: [
					{
						title: "NIS-2 Relevanz",
						description:
							"Viele Unternehmen wissen nicht, ob sie von der NIS-2-Richtlinie betroffen sind. Eine Fehleinschätzung führt zu unnötigem Aufwand – oder zu hohen Strafen.",
						module: "Betroffenheits- & GAP-Analyse",
						solution:
							"Der kostenlose Schnellcheck zeigt Ihnen in 3 Minuten, ob Sie betroffen sind – und erzeugt daraus direkt Ihren individuellen Maßnahmenplan.",
					},
					{
						title: "Gesetzliche Vorgaben",
						description:
							"Melde- und Dokumentationspflichten wie auch Sicherheitsmaßnahmen sind mitunter komplex. Schon kleine Fehler in der Umsetzung können Sanktionen und Geldstrafen nach sich ziehen.",
						module: "Maßnahmenplan & Aufgaben-Board",
						solution:
							"NIS360 übersetzt Gesetze in To-Dos – alle Anforderungen werden zu konkreten Aufgaben mit Prioritäten, Verantwortlichen und auditfesten Nachweisen.",
					},
					{
						title: "Lieferkettenrisiken",
						description:
							"Ein Sicherheitsvorfall bei einem einzigen Partner kann das ganze Unternehmen gefährden.",
						module: "Lieferketten-Risikobewertung",
						solution:
							"NIS360 bewertet Risiken in der Lieferkette systematisch und liefert konkrete Handlungsanweisungen zur gegenseitigen Absicherung.",
					},
				],
			},
			landingProductShowcase: {
				title: "Eine Plattform für Ihre gesamte NIS-2-Umsetzung",
				description:
					"Vom ersten Check bis zum Audit-Nachweis: NIS360 macht aus abstrakten Anforderungen konkrete Arbeit, die Ihr Team Schritt für Schritt erledigt.",
				features: [
					{
						kicker: "INDIVIDUELLER MAẞNAHMENPLAN",
						title:
							"Aus Ihrer Analyse werden automatisch 30+ konkrete, priorisierte Aufgaben extrahiert",
						description:
							"Jede Aufgabe enthält eine verständliche Umsetzungsanleitung – Sie wissen immer, was als Nächstes zu tun ist und warum.",
					},
					{
						kicker: "FORTSCHRITT & VERANTWORTLICHKEITEN",
						title: "Jeder weiß, was zu tun ist. Sie sehen jederzeit, wo Sie stehen.",
						description:
							"Kanban-Board, Prioritäten und Review-Workflow: Aufgaben werden verteilt, der Fortschritt ist messbar – und dem Prüfer jederzeit vorzeigbar.",
					},
					{
						kicker: "TEAM-KOLLABORATION",
						title: "Holen Sie IT, Geschäftsführung und Datenschutz an einen Tisch",
						description:
							"Laden Sie Ihr Team mit Rollen und Rechten ein. Verantwortlichkeiten sind klar geregelt – ohne lange E-Mail-Verläufe und Excel-Listen.",
					},
					{
						kicker: "KI-ASSISTENT",
						title: "Fragen zur Umsetzung? Sofort beantwortet – im Kontext Ihrer Aufgabe",
						description:
							"Der NIS-2-Assistent kennt Ihre aktuelle Aufgabe und antwortet fundiert – trainiert auf BSIG, BSI-Grundschutz und ISO 27001.",
					},
				],
			},
			landingStats: {
				items: [
					{ value: "30+", label: "konkrete Maßnahmen in Ihrem Plan" },
					{ value: "3 Min.", label: "bis zu Ihrem ersten Ergebnis" },
					{ value: "Made in Germany", label: "Hosting in einem deutschen Rechenzentrum" },
					{ value: "BSIG · ISO 27001", label: "fachliche Grundlage der Plattform" },
				],
			},
			landingRisk: {
				kicker: "Was auf dem Spiel steht",
				title: "NIS-2 ist keine Empfehlung – sondern Pflicht mit Konsequenzen",
				subtitle:
					"Die Richtlinie ist in Kraft getreten und unmittelbar anzuwenden. Wer nicht handelt, riskiert empfindliche Bußgelder, persönliche Haftung und Reputationsschäden.",
				items: [
					{
						title: "Bußgelder bis 10 Mio. €",
						description:
							"Bei Verstößen drohen Geldbußen von bis zu 10 Mio. € oder 2 % des weltweiten Jahresumsatzes – je nachdem, welcher Betrag höher ist.",
					},
					{
						title: "Persönliche Geschäftsführerhaftung",
						description:
							"Die Geschäftsleitung muss Risikomaßnahmen genehmigen und überwachen – und haftet bei Versäumnissen persönlich. Diese Pflicht ist nicht delegierbar.",
					},
					{
						title: "Die Frist läuft bereits",
						description:
							"NIS-2 gilt EU-weit seit Oktober 2024. Aufsichtsbehörden können Betroffenheit, Maßnahmen und Nachweise jederzeit prüfen.",
					},
				],
			},
			landingAffected: {
				kicker: "Bin ich betroffen?",
				title: "NIS-2 betrifft weit mehr Unternehmen als gedacht",
				subtitle:
					"Wer mindestens zwei dieser Schwellenwerte erreicht, fällt in der Regel unter NIS-2 – häufig auch als Zulieferer eines betroffenen Unternehmens.",
				criteria: [
					{ value: "50+", label: "Mitarbeitende (mittlere & große Unternehmen)" },
					{ value: "10 Mio. € +", label: "Jahresumsatz oder Bilanzsumme" },
					{ value: "18 Sektoren", label: "u. a. Energie, Gesundheit, Transport, IT, Lebensmittel" },
				],
				note: "Auch kleinere Unternehmen können als Teil der Lieferkette betroffen sein – etwa als Dienstleister oder Zulieferer.",
				ctaTitle: "Unsicher, ob NIS-2 für Sie gilt?",
				ctaButton: "In 3 Minuten Betroffenheit prüfen",
			},
			landingComparison: {
				kicker: "Warum NIS360",
				title: "NIS360 im Vergleich zu den Alternativen",
				subtitle:
					"Excel-Listen, teure Einzelberatung oder generische GRC-Tools – so schneidet NIS360 im direkten Vergleich ab.",
				featureHeader: "Anforderung",
				columns: ["Excel & E-Mail", "Externe Beratung", "Generisches GRC-Tool", "NIS360"],
				highlightLabel: "Empfohlen",
				rows: [
					{ feature: "NIS-2-spezifischer Maßnahmenplan", values: ["no", "yes", "no", "yes"] },
					{ feature: "Sofort startklar (3 Min.)", values: ["no", "no", "no", "yes"] },
					{ feature: "Planbare Kosten statt Tagessätze", values: ["partial", "no", "yes", "yes"] },
					{
						feature: "Auditfeste Nachweise auf Knopfdruck",
						values: ["no", "partial", "partial", "yes"],
					},
					{
						feature: "Team-Kollaboration mit Rollen & Rechten",
						values: ["no", "no", "partial", "yes"],
					},
					{ feature: "KI-Assistent für die Umsetzung", values: ["no", "no", "no", "yes"] },
					{ feature: "Laufend aktuell ohne Mehrkosten", values: ["no", "no", "partial", "yes"] },
				],
			},
			landingSecurity: {
				kicker: "Sicherheit & Datenschutz",
				title: "Ihre Daten bleiben in Deutschland",
				description:
					"Eine Plattform für Cybersicherheit muss selbst höchsten Ansprüchen genügen. NIS360 wird vollständig in einem deutschen Rechenzentrum betrieben – Ihre Daten verlassen Deutschland nicht.",
				items: [
					{
						title: "Hosting in Deutschland",
						description:
							"Betrieb in einem Rechenzentrum in Nürnberg – keine Datenübermittlung in Drittländer.",
					},
					{
						title: "DSGVO-konforme Verarbeitung",
						description:
							"Verarbeitung nach den Vorgaben der DSGVO. Auftragsverarbeitungsvertrag auf Wunsch.",
					},
					{
						title: "Verschlüsselte Übertragung",
						description: "Alle Verbindungen werden durchgängig per TLS verschlüsselt.",
					},
				],
			},
			landingLeadMagnet: {
				title: "Wo steht Ihr Unternehmen? Finden Sie es in 3 Minuten heraus.",
				bullets: [
					"Kostenlos und ohne Registrierung startbar",
					"Sofortiges Ergebnis: Betroffenheit und Lücken auf einen Blick",
					"Ihr persönlicher Maßnahmenüberblick als PDF",
				],
				ctaButton: "Schnellcheck starten",
				registerHint: "Schon überzeugt?",
				registerLink: "Direkt registrieren",
			},
			landingTwoColumns: {
				title: "Überblick",
				description:
					"NIS360 – Ihr Werkzeug für NIS-2-Compliance und Cybersicherheit Mit NIS360 erhalten Unternehmen eine praxisorientierte Lösung, um die Anforderungen der NIS-2-Richtlinie effizient und auditierbar umzusetzen. Unser Tool unterstützt Sie bei Risikobewertung, Umsetzung technischer und organisatorischer Maßnahmen sowie beim kontinuierlichen Monitoring.",
				leftColumn: {
					title: "Integrieren Sie NIS360 in Ihre Unternehmensprozesse",
					description:
						"Um NIS-2-Anforderungen praxisnah umzusetzen, verbindet NIS360 Ihre bestehenden Strukturen mit einem intelligenten Fragen- und Aufgabenmanagement. So wird Compliance nicht nur theoretisch abgebildet, sondern realistisch in Ihre täglichen Abläufe integriert – für nachvollziehbare Nachweise und nachhaltige Sicherheit.",
				},
				rightColumn: {
					title: "Bereiten Sie sich auf komplexe Compliance Anforderungen vor",
					description:
						"Die NIS-2-Richtlinie stellt Unternehmen vor umfassende Anforderungen an Cybersicherheit und Risikomanagement. Präzise Planung, strukturierte Prozesse und schnelle Reaktionen sind entscheidend, um rechtliche und finanzielle Risiken wirksam zu minimieren.",
				},
			},
			landingWhyNIS2MattersSection: {
				title: "Bereiten Sie sich auf komplexe Compliance Anforderungen vor",
				description:
					"Komplexe Compliance-Anforderungen warten nicht, der regulatorische Druck wächst, Fristen rücken näher und Verantwortlichkeiten müssen klar geregelt sein. Wir helfen Ihnen, den Überblick zu behalten: strukturiert, praxisnah und auf Ihr Unternehmen zugeschnitten – damit Sie compliant bleiben und Risiken gezielt minimieren.",
				features: [
					{
						alt: "Organisatorische Maßnahmen Symbol",
						text: "Hohe Verbindlichkeit sorgt für Rechtssicherheit",
					},
					{
						alt: "Bußgeld Symbol",
						text: "Hohe Transparenz fördert Vertrauen",
					},
					{
						alt: "KMU Symbol",
						text: "Praxisnähe steigert die Effizienz",
					},

					{
						alt: "Meldung von Sicherheitsvorfällen Symbol",
						text: "Klarheit ermöglicht Handlungssicherheit",
					},
					{
						alt: "Meldung von Sicherheitsvorfällen Symbol",
						text: "Kontinuität stärkt die Resilienz",
					},
				],
				imageAlt: "Warum NIS-2 wichtig ist",
			},
			landingHowItWorksSection: {
				title: "In vier Schritten zur nachweisbaren Compliance",
				description:
					"Der kostenlose Schnellcheck ist Schritt 1 – er erzeugt Ihren individuellen Maßnahmenplan in der Plattform.",
				steps: [
					{
						step: "Schritt 1",
						title: "Schnellcheck",
						description:
							"3 Minuten, kostenlos: Betroffenheits- und GAP-Analyse für Ihr Unternehmen",
						badgeColor: "#FFEDE6",
					},
					{
						step: "Schritt 2",
						title: "Maßnahmenplan erhalten",
						description:
							"Ihr individueller Fahrplan mit 30+ priorisierten Aufgaben und Umsetzungsanleitungen",
						badgeColor: "#FEEAA3",
					},
					{
						step: "Schritt 3",
						title: "Strukturiert umsetzen",
						description:
							"Aufgaben im Team verteilen, Fortschritt verfolgen, KI-Hilfe direkt in der Aufgabe nutzen",
						badgeColor: "#E8E6E2",
					},
					{
						step: "Schritt 4",
						title: "Nachweisen & bestehen",
						description: "Auditfeste Dokumentation für Behörde und Prüfer – jederzeit exportierbar",
						badgeColor: "#DAF8E6",
						imgWidth: 100,
						imgHeight: 88,
					},
				],
				startCheckButton: "Jetzt mit Schritt 1 starten – Schnellcheck",
				arrowLeftAlt: "Arrow left",
			},
			landingContactSection: {
				title: "Haben Sie Fragen?",
				description: "Kontaktieren Sie uns einfach.",
				success: "Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns bei Ihnen.",
				form: {
					title: "Kontaktieren Sie uns",
					description: "Senden Sie uns einfach eine Nachricht. Wir melden uns bei Ihnen.",
					confirm: "Bestätigen",
				},
				name: "Name",
				namePlaceholder: "Geben Sie Ihren Namen ein",
				emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
				messagePlaceholder: "Geben Sie Ihre Nachricht ein",
				email: "E-Mail-Adresse",
				message: "Nachricht",
			},
			landingExpertsSection: {
				title: "Ihre Experten für NIS-2-Compliance",
				description:
					"MACONIA ist spezialisiert auf IT-Sicherheitsberatung für mittelständische Unternehmen. Wir helfen Ihnen, die Anforderungen der NIS-2-Richtlinie rechtssicher und pragmatisch umzusetzen.",
				features: [
					{
						alt: "Bewertung",
						text: "> 10 Jahre Erfahrung in der IT-Sicherheitsberatung",
					},
					{
						alt: "Expertise",
						text: "Beratung nach BSI-Grundschutz, ISO 27001 und EU-Vorgaben",
					},
				],
				dataPrivacy: {
					title: "Von Praktikern anwendungsorientiert entwickelt. Aus der Praxis für die Praxis.",
					description:
						"NIS360 entstand aus der täglichen Beratungspraxis der MACONIA GmbH. Alle Funktionen entsprechen standardisierten Vorgehensweisen, die für alle NIS-2 Projekte genutzt werden können.",
					padlockAlt: "Vorhängeschloss",
				},
			},
			landingTestimonials: {
				testimonials: [
					{
						quote:
							"MACONIA hat uns dabei geholfen, die NIS-2-Anforderungen strukturiert und effizient umzusetzen. Sehr empfehlenswert für mittelständische Unternehmen.",
						name: "Gabrielle Williams",
						title: "Geschäftsführerin, Technologieunternehmen",
					},
					{
						quote:
							"Professionelle Unterstützung von Anfang bis Ende. Unsere Sicherheitsanforderungen wurden vollständig erfüllt.",
						name: "Lukas Steiner",
						title: "IT-Leiter, Finanzdienstleister",
					},
					{
						quote:
							"Dank MACONIA konnten wir die Compliance-Anforderungen termingerecht erfüllen. Top Beratung!",
						name: "Anja Richter",
						title: "Geschäftsführerin, Industrieunternehmen",
					},
				],
				quoteAlt: "Zitat Symbol",
				avatarAlt: "Avatar",
				sliderLeftAlt: "Slider links",
				sliderRightAlt: "Slider rechts",
			},
			landingCTASection: {
				ctaTitle: "Jetzt NIS-2-Relevanz prüfen – kostenlos & in nur 3 Minuten",
				ctaButton: "Schnellcheck starten",
				footerAlt: "Footer Illustration",
				imprint: "Impressum",
				privacyPolicy: "Datenschutzerklärung",
				copyright: "Copyright © 2026 MACONIA GmbH. Alle Rechte vorbehalten.",
			},
			start: {
				title: "Bewerten Sie Ihre Cybersicherheit gemäß NIS-2!",
				"get-started": "Loslegen",
				"description-first":
					"Die europäische NIS-2-Richtlinie legt neue Cybersicherheitsanforderungen für Unternehmen im öffentlichen und kritischen Sektor fest. Sie müssen eine Bewertung durchführen, um Ihre Konformität zu überprüfen und eine Liste mit wichtigen Maßnahmen zur Verbesserung Ihrer Sicherheit zu erhalten.",
				"description-first-highlight": "NIS-2-Richtlinie",
				"description-second": "Diese Umfrage hilft Ihnen:",
				"description-second-list": {
					"1": "Schwachstellen in Ihrem Sicherheitssystem zu identifizieren;",
					"2": "Personalisierte Empfehlungen zur Einhaltung der NIS-2-Richtlinie zu erhalten;",
					"3": "Eine To-do-Liste zur Verbesserung Ihrer Cybersicherheit zu erstellen;",
				},
				"description-third":
					"Der Prozess dauert nur wenige Minuten. Bitte geben Sie ehrliche Antworten, um die genaueste Analyse zu erhalten.",
				"description-third-highlight": "nur wenige Minuten",
				"compliance-question": "Müssen Sie die NIS-2-Richtlinie einhalten?",
				yes: "Ja",
				no: "Nein",
				idk: "Ich weiß es nicht",
			},
			progress: {
				back: "Zurück",
				next: "Weiter",
				finish: "Ergebnisse erhalten",
				readLess: "Weniger lesen",
				readMore: "Mehr lesen",
				step: "Schritt {{currentStep}} von {{totalLength}}",
				subStep: "Zwischenschritt {{currentStep}} von {{totalLength}}",
			},
			finalize: {
				introduction: {
					title: "Das wichtigste auf einen Blick",
				},
				"back-to-start": "Zurück zum Start",
				continue: "Fortsetzen",
				"to-registration": "Zur Registrierung",
				title: "Ihre NIS-2-Compliance Roadmap",
				subtitle:
					"Wir haben Ihnen eine personalisierte Roadmap erstellt, um Ihre Compliance mit NIS-2 zu gewährleisten.",
				overallComplianceLevel: "Gesamtes Compliance-Niveau:",
				"overallComplianceLevel-description":
					"Basierend auf Ihren Antworten erfüllt Ihr Unternehmen einige NIS-2-Anforderungen, benötigt jedoch Verbesserungen in wichtigen Bereichen, um die vollständige Compliance sicherzustellen. Unten finden Sie Ihren persönlichen Aktionsplan.",
				"overallComplianceLevel-description-not-needed":
					"Basierend auf den Umfrageergebnissen erfordert Ihre Organisation keine Einhaltung der NIS-2-Vorgaben. Das bedeutet, dass Sie vorerst die in dieser Richtlinie festgelegten Cybersecurity-Anforderungen nicht erfüllen müssen.",
				"critical-gaps": "Kritische Sicherheitslücken (Sehr wichtig) - {{count}}",
				"key-improvements": "Wichtige Sicherheitsverbesserungen erforderlich (Wichtig) - {{count}}",
				"next-steps": "Nächste Schritte:",
				"next-steps-description":
					"Um einen detaillierten personalisierten Aktionsplan (To-Do-Liste) einzusehen, den Fortschritt bei jeder Aufgabe zu verfolgen und Empfehlungen zu erhalten, registrieren Sie sich bitte.",
				"next-steps-description-highlight": "registrieren Sie sich bitte.",

				[QuestionnaireImportance.IMPORTANT]: "Wichtig",
				[QuestionnaireImportance.NONE]: "Von NIS-2 nicht berücksichtigt",
				[QuestionnaireImportance.STOP]: "Muss nicht mit NIS-2 konform sein",
				"first-pass-questionnaire":
					"Um sich zu registrieren, müssen Sie zunächst einen Fragebogen ausfüllen, um den Kritikalitätsgrad Ihres Unternehmens zu bestimmen.",
				"to-questionnaire": "Zum Fragebogen",
				"company-registration": "Registrierung",
				"questionnaire-required": "Das Ausfüllen des Fragebogens ist erforderlich",
				planPreview: {
					title: "Vorschau: Ihr persönlicher Maßnahmenplan",
					visibleCount: "3 von 32 Maßnahmen sichtbar",
					visibleTasks: [
						{
							title: "Risikoanalyse für kritische Systeme durchführen",
							category: "Risikomanagement",
						},
						{
							title: "Meldewege für Sicherheitsvorfälle einrichten (24h-Frist)",
							category: "Incident Response",
						},
						{
							title: "Verantwortlichkeiten für Informationssicherheit festlegen",
							category: "Governance",
						},
					],
					blurredTasks: [
						{
							title: "Multi-Faktor-Authentifizierung für kritische Konten umsetzen",
							category: "Technische Maßnahmen",
						},
						{
							title: "Backup- und Wiederherstellungskonzept dokumentieren",
							category: "Business Continuity",
						},
						{
							title: "Schulungsplan für die Geschäftsleitung erstellen",
							category: "Awareness",
						},
					],
					overlayText:
						"Registrieren Sie sich kostenlos, um den vollständigen Plan mit allen Aufgaben und Anleitungen zu sehen.",
				},
			},
			cybersecurity: {
				title: "Möchten Sie dennoch Ihre Cybersicherheit überprüfen?",
				description:
					"Auch wenn Sie nicht zur Einhaltung der NIS-2 verpflichtet sind, kann es dennoch hilfreich sein, Ihr Cybersicherheitsniveau zu verstehen.",
				yes: "Ja",
			},
			introduction: {
				title: "Willkommen zum NIS-2 Selbstcheck",
				text: "Dieser Selbstcheck besteht aus einer kurzen Betroffenheitsprüfung, gefolgt von einer GAP-Analyse. - Geschätzter Zeitaufwand 3-4 min.",
				continue: "Weiter",
			},
			business: {
				industry: {
					title:
						" In welchem Sektor gemäß Anlage 1 und Anlage 2 BSIG ist Ihr Unternehmen hauptsächlich tätig? ",
					description: "",
				},
				size: {
					title: "Wie groß ist Ihr Unternehmen?",
					description: "Geben Sie die Größe basierend auf der Anzahl der Mitarbeitenden an.",
				},
				turnover: {
					title: "Wie hoch ist der Jahresumsatz in Ihrem Unternehmen?",
					description: "Geben Sie den jährlichen Umsatz in Millionen € an.",
				},
				balance: {
					title: "Wie hoch ist die Jahresbilanz in Ihrem Unternehmen?",
					description: "Geben Sie die jährliche Bilanzsumme in Millionen € an.",
				},
				progress: {
					back: "Zurück",
					next: "Weiter",
					finish: "Fertigstellen",
					step: "Schritt {{currentStep}} von {{totalLength}}",
					subStep: "Zwischenschritt {{currentStep}} von {{totalLength}}",
				},
			},
			"needs-analysis": {
				progress: {
					back: "Zurück",
					next: "Weiter",
					finish: "Fertigstellen",
					step: "Schritt {{currentStep}} von {{totalLength}}",
					subStep: "Zwischenschritt {{currentStep}} von {{totalLength}}",
				},
				finalize: {
					continue: "Weiter",
					"back-to-start": "Zurück zum Anfang",
					"to-registration": "Zur Registrierung",
					title: "Ihre NIS-2-Konformitätsergebnisse!",
					overallComplianceLevel: "Gesamtkonformitätsgrad:",
					"overallComplianceLevel-description":
						"Basierend auf Ihren Antworten erfüllt Ihr Unternehmen einige Anforderungen der NIS-2-Richtlinie, benötigt jedoch Verbesserungen in wichtigen Bereichen, um vollständig konform zu sein. Unten finden Sie Ihren personalisierten Maßnahmenplan.",
					"overallComplianceLevel-description-not-needed":
						"Basierend auf den Umfrageergebnissen muss Ihre Organisation derzeit nicht den Anforderungen der NIS-2-Richtlinie entsprechen. Das bedeutet, dass Sie aktuell keine Maßnahmen zur Cybersicherheit gemäß dieser Richtlinie umsetzen müssen.",
					"critical-gaps": "Kritische Sicherheitslücken (Sehr wichtig) – {{count}}",
					"key-improvements":
						"Wichtige Sicherheitsverbesserungen erforderlich (Wichtig) – {{count}}",
					"next-steps": "Nächste Schritte:",
					"next-steps-description":
						"Um einen detaillierten, personalisierten Maßnahmenplan (To-do-Liste) einzusehen, den Fortschritt bei jeder Aufgabe zu verfolgen und Empfehlungen zu erhalten, registrieren Sie sich bitte.",
					"next-steps-description-highlight": "registrieren Sie sich bitte.",
					IMPORTANT: "Wichtig",
					VERY_IMPORTANT: "Sehr wichtig",
					NONE: "Nicht von NIS-2 betroffen",
					STOP: "Nicht zur Einhaltung der NIS-2 verpflichtet",
					"first-pass-questionnaire":
						"Um sich zu registrieren, müssen Sie zunächst einen Fragebogen ausfüllen, um die Kritikalität Ihres Unternehmens zu ermitteln.",
					"to-questionnaire": "Zum Fragebogen",
					"company-registration": "Registrierung",
					"questionnaire-required": "Das Ausfüllen des Fragebogens ist erforderlich",
					"self-assessment-text":
						"Basierend auf Ihren Antworten <1>muss Ihr Unternehmen der NIS-2-Richtlinie entsprechen</1>. Der nächste Schritt ist eine Selbsteinschätzung. Klicken Sie unten auf die Schaltfläche, um die Bewertung zu starten.",
					"cybersecurity-prompt-text":
						"Ihr Unternehmen <1>ist nicht verpflichtet, der NIS-2-Richtlinie zu entsprechen</1>. Möchten Sie dennoch Ihre Cybersicherheit überprüfen?",
					"start-self-assessment": "Selbsteinschätzung starten",
					"check-cybersecurity": "Ja",
				},
			},
			"self-assessment": {
				yes: "Ja",
				no: "Nein",
				skip: "Nein",
				progress: {
					back: "Zurück",
					next: "Weiter",
					finish: "Fertigstellen",
					step: "Schritt {{currentStep}} von {{totalLength}}",
					subStep: "Zwischenschritt {{currentStep}} von {{totalLength}}",
				},
				finalize: {
					title: "Selbsteinschätzung abgeschlossen",
					"summary-text":
						"Sie haben die Selbsteinschätzung abgeschlossen. Ihre Antworten wurden überprüft und die erforderlichen Aufgaben werden während der Registrierung erstellt.",
					"proceed-to-registration": "Zur Registrierung fortfahren",
				},
			},
		},
		"to-do": {
			[ToDoStatus.QA]: "Überprüfung",
			none: "Keine",
			"cannot-move-subtask-to-done":
				"Nur Unteraufgaben in der Spalte „Uberprufung“ können in die Spalte „erledigt“ verschoben werden",
			"cannot-move-task-to-done":
				"Nur Aufgaben in der Spalte „Uberprufung“ können in die Spalte „erledigt“ verschoben werden",
			"show-less": "Weniger anzeigen",
			"show-more": "Alle Kategorien anzeigen",
			"overall-progress": "Gesamter Fortschritt",
			"tasks-completed": "Aufgaben abgeschlossen",
			priority: "Priorität",
			"qa-assignee": "Änderung des Beauftragten zur Überprüfung",
			"qa-assignee-task":
				"Sie müssen die Person auswählen, die für die Überprüfungsphase dieser Aufgabe verantwortlich ist.",
			"qa-assignee-subtask":
				"Sie müssen die Person auswählen, die für die Überprüfungsphase dieser Unteraufgabe verantwortlich ist.",
			search: "Aufgaben suchen...",
			title: "Aufgabenliste",
			all: "Alle",
			"i-see": "Verstanden",
			recommendation: "Empfehlung",
			requirement: "Allgemeine Anforderungen",
			"date-created": "Erstellungsdatum:",
			"list-empty": "Liste ist leer",
			"change-task-status": "Ändere den Aufgabenstatus zu",
			category: "Kategorie:",
			subTask: "Unteraufgabe",
			[ToDoStatus.TO_DO]: "Zu erledigen",
			[ToDoStatus.IN_PROGRESS]: "In Bearbeitung",
			[ToDoStatus.DONE]: "Erledigt",
			[ToDoPriority.LOW]: "Niedrig",
			[ToDoPriority.MEDIUM]: "Mittel",
			[ToDoPriority.HIGH]: "Hoch",

			statistic: {
				[StatisticType.TOTAL]: "Gesamtaufgaben",
				[StatisticType.REMAINING]: "Verbleibende Aufgaben",
				[StatisticType.COMPLETED]: "Abgeschlossene Aufgaben",
			},
			subTasks: "Unteraufgaben",
			subtaskProgress: "{{done}} von {{total}} erledigt",
			activity: "Aktivität",
			comments: "Kommentare",
			historyTab: "Verlauf",
			noComments: "Noch nichts gesagt.",
			noHistory: "Noch keine Änderungen aufgezeichnet.",
			moveTo: "Verschieben nach",
			created: "Erstellt",
			updated: "Aktualisiert",
			backToTask: "Zur Aufgabe",
			unsaved: {
				badge: "Nicht gespeichert",
				title: "Ungespeicherte Änderungen",
				description:
					"Sie haben Änderungen vorgenommen, die noch nicht gespeichert wurden. Was möchten Sie tun?",
				keepEditing: "Weiter bearbeiten",
				discard: "Verwerfen",
				saveAndClose: "Speichern & fortfahren",
			},
			activityLog: {
				unknownUser: "Unbekannt",
				entityTask: "die Aufgabe",
				entitySubtask: "die Unteraufgabe",
				empty: "—",
				textChanged: "geändert",
				fields: {
					title: "Titel",
					description: "Beschreibung",
					status: "Status",
					priority: "Priorität",
					complexityEstimate: "Komplexität",
					tagId: "Tag",
					assigneeId: "Zuständige Person",
				},
				HISTORY: {
					CREATE: "{{user}} hat {{entity}} erstellt",
					UPDATE: "{{user}} hat {{entity}} aktualisiert",
					DELETE: "{{user}} hat {{entity}} gelöscht",
				},
				COMMENT: {
					CREATE: "{{user}} hat einen Kommentar hinzugefügt",
					UPDATE: "{{user}} hat einen Kommentar bearbeitet",
					DELETE: "{{user}} hat einen Kommentar gelöscht",
				},
			},
			description: "Beschreibung",
			onYourMind: "Was beschäftigt Sie?",
			addComment: "Kommentar hinzufügen...",
			untagged: "Ohne Kategorie",
			inherited: "Vererbt",
		},
		sidebar: {
			users: "Benutzer",
			roles: "Benutzerrollen",
			logout: "Abmelden",
			accounts: "Konten",
			settings: "Einstellungen",
			accountSettings: "Kontoeinstellungen",
			profile: "Mein Profil",
			companies: "Kunden",
			back: "Zurück zu deinem Account",
			all: "Alle",
			listViews: "Ansichten auflisten",
			campaigns: "Kampagnen",
			company: "Unternehmen",
			menu: "Menü",
			"my-profile": "Mein Profil",
			"to-do-list": "To-Do Liste",
			"swimlane-board": "Swimlane Board",
			team: "Team",
			"manage-to-do": "To-Dos",
			"manage-questionnaire": "Bedarfsanalyse",
			"manage-industries": "Sektoren",
			"manage-company-size": "#Mitarbeiter",
			"manage-company-revenue": "Umsätze",
			"manage-company-balance": "Jahresbilanz",
			"manage-task-templates": "Aufgabenvorlagen",
			admin: "Admin",
		},
		errors: {
			invalidEmail: "Ungültige E-Mail-Adresse",
			invalidPassword: "Ungültiges Passwort",
			passwordGuidelinesNotMet: "Passwortrichtlinien nicht erfüllt",
			termsAcceptanceMissing: "Bitte akzeptieren Sie die Nutzungsbedingungen",
			invalidValue: "Ungültiger Wert",
			invalidData: "Ungültige Daten",
			userNotConfirmed: "Benutzer nicht bestätigt",
			passwordMismatch: "Passwörter stimmen nicht überein",
			invalidToken: "Ungültiges Token",
			emailAlreadyTaken: "E-Mail-Adresse bereits vergeben",
			wentWrong: "Etwas ist schief gelaufen",
			unauthorized: "Nicht autorisiert",
			invalidAuthCode: "Ungültiger Authentifizierungscode",
			nameMissing: "Name fehlt",
			requiredFields: "Nicht alle erforderlichen Felder sind ausgefüllt.",
			expectedNumber: "Nummer erwartet / geben Sie 0 ein, wenn nicht benötigt.",
			customColumnAlreadyExists: "Spalte existiert bereits",
			wrongUrlShouldBeLinkedinProfile: "Falsche URL. Sollte eine LinkedIn-Profil-URL sein",
			notEnoughCredits: "Nicht genügend Credits",
			notAcceptedCompany: "Ihr Unternehmen wurde noch nicht bestätigt",
			notConfirmedEmail: "Ihre E-Mail wurde noch nicht bestätigt",
			tokenWasUsed: "Bereits bestätigt",
			answersRequired: "Der Fragebogen muss mindestens eine Antwort enthalten",
		},
		team: {
			title: "Team",
		},
		account: {
			connectionScraping: "LinkedIn-Verbindungen",
			enableConnectionScraping: "Scraping deiner LinkedIn-Verbindungen aktivieren",
			enableConnectionScrapingDescription:
				"Dies ermöglicht zu ermitteln zu welchen Prospects du oder deine Kollegen bereits eine Verindung auf Linkedin haben.",
			linkedinAutomation: "LinkedIn-Automatisierung",
			enableAutoAccept: "Auto-Akzeptieren aktivieren",
			enableAutoAcceptDescription: "Automatisches Akzeptieren von LinkedIn-Verbindungsanfragen",
			profileVisits: "Profilbesuche",
			warningPremiumAccountRequired: "Premium-Account erforderlich",
			enableProfileVisitsScraping: "Profilbesuche aktivieren",
			changePassword: "Passwort ändern",
			currentPassword: "Aktuelles Passwort",
			disableTwoFactorAuth: "2FA deaktivieren",
			enableTwoFactorAuth: "2FA aktivieren",
			enableTwoFactorAuthDescription: "Scannen Sie den QR-Code mit Ihrer Authentifizierungs-App",
			newPassword: "Neues Passwort",
			profileInformation: "Profilinformationen",
			profileSecurity: "Profilsicherheit",
			repeatPassword: "Neues Passwort wiederholen",
			tabs: {
				general: "Allgemein",
				notifications: "Benachrichtigungen",
				linkedinConnections: "LinkedIn-Verbindungen",
			},
			title: "Persönliche Informationen",
			description: "Aktualisieren Sie hier Ihre persönlichen Daten und Einstellungen.",
			save: "Änderungen speichern",
			saving: "Speichern...",
			cancel: "Abbrechen",
			linkedinConnections: "LinkedIn-Verbindungen",
		},
		notifications: {
			panel: {
				title: "Benachrichtigungen",
				markAllRead: "Alle als gelesen markieren",
				tabs: {
					all: "Alle",
					unread: "Ungelesen",
				},
				allCategories: "Alle Kategorien",
				categories: {
					assignment: "Zuweisung",
					status: "Status",
					comment: "Kommentar",
					tag: "Tag",
					system: "System",
				},
				loading: "Wird geladen…",
				empty: "Keine Benachrichtigungen",
				allCaughtUp: "Du bist auf dem neuesten Stand!",
				previous: "← Zurück",
				next: "Weiter →",
				pageOf: "Seite {{page}} von {{totalPages}}",
			},
			item: {
				fallbackTitle: "Benachrichtigung",
				aggregatedItems: "{{count}} Einträge",
			},
			toast: {
				fallbackTitle: "Benachrichtigung",
			},
			preferences: {
				title: "Benachrichtigungseinstellungen",
				subtitle: "Legen Sie fest, welche Benachrichtigungen Sie erhalten und auf welchem Weg.",
				headers: {
					group: "Gruppe",
					inApp: "In-App",
					email: "E-Mail",
					digest: "Übersicht",
					digestTooltip:
						"Wenn aktiviert, erhalten Sie eine gesammelte Übersicht aller Benachrichtigungen dieser Kategorie – im Intervall, das Sie in der Spalte „Häufigkeit“ wählen – statt einzelner Benachrichtigungen für jedes Ereignis. Nutzen Sie diese Option, wenn Sie informiert bleiben möchten, ohne durch jede einzelne Aktualisierung unterbrochen zu werden. Die Spalte „Häufigkeit“ legt fest, wie oft die Übersicht versendet wird (täglich oder wöchentlich). Ist die Häufigkeit auf „Sofort“ oder „Aus“ gesetzt, wird keine Übersicht gesendet.",
					frequency: "Häufigkeit",
				},
				frequencyOptions: {
					instant: "Sofort",
					daily: "Täglich",
					weekly: "Wöchentlich",
					off: "Aus",
				},
				loading: "Einstellungen werden geladen…",
				resetToDefaults: "Auf Standard zurücksetzen",
			},
		},
		basics: {
			additionalInfo: "Zusätzliche Informationen",
			question: "Frage",
			subTaskTitle: "Anforderung",
			measure: "Maßnahme",
			"to-registration": "Zum Download",
			"self-assessment": {
				yes: "Ja",
				no: "Nur Teilweise umgesetzt",
			},
			yes: "Ja",
			no: "Nein",
			"resend-invite": "Einladung erneut senden",
			"rows-per-page": "Zeilen pro Seite:",
			selectColumns: "Spalten auswählen",
			wait: "Bitte warten",
			reset: "Zurücksetzen",
			pleaseSelect: "Bitte wählen",
			noResults: "Keine Ergebnisse",
			account: "Konto",
			actions: "Aktionen",
			admin: "Admin",
			back: "Zurück",
			block: "Blockieren",
			companyName: "Firmenname",
			cancel: "Abbrechen",
			change: "Bearbeiten",
			add: "Hinzufügen",
			code: "Code",
			confirmationClose: "Sind Sie sicher, dass Sie das Fenster schließen wollen?",
			confirm: "Bestätigen",
			confirmPassword: "Passwort bestätigen",
			createSomething: "Erstelle {{something}}",
			delete: "Löschen",
			description: "Beschreibung",
			dragAndDropImage: "Ziehen & Ablegen",
			edit: "Bearbeiten",
			editSomething: "Bearbeite {{something}}",
			email: "E-Mail-Adresse",
			enterSomething: "Geben Sie Ihre {{something}} ein",
			enterFirstName: "Geben Sie Ihren Vornamen ein",
			enterLastName: "Geben Sie Ihren Nachnamen ein",
			enterCompanyName: "Geben Sie Ihren Firmennamen ein",
			enterPassword: "Geben Sie Ihr Passwort ein",
			enterConfirmPassword: "Bestätigen Sie Ihr Passwort",
			firstName: "Vorname",
			home: "Startseite",
			label: "Etikett",
			lastName: "Nachname",
			linkedinUrl: "LinkedIn URL",
			logout: "Abmelden",
			name: "Name",
			noData: "Keine Daten",
			password: "Passwort",
			permissions: "Berechtigungen",
			resetPassword: "Passwort zurücksetzen",
			role: "Rolle",
			save: "Speichern",
			saveChanges: "Änderungen speichern",
			search: "Suche {{something}}...",
			select: "Auswählen",
			selectSomething: "Wähle {{something}}",
			setPassword: "Passwort festlegen",
			status: "Status",
			termsAndConditions:
				"<noLink>Ich stimme den </noLink> <link1>Allgemeinen Geschäftsbedingungen</link1> <noLink>zu</noLink>",
			termsAndConditionsObject: {
				noLink: "Ich stimme den ",
				link1: "Allgemeinen Geschäftsbedingungen",
				noLink2: "zu",
			},
			privacyStatement:
				"<noLink>Ich stimme der </noLink> <link1>Datenschutzerklärung</link1> <noLink>zu.</noLink>",
			privacyStatementObject: {
				noLink: "Ich stimme der ",
				link1: "Datenschutzerklärung",
				noLink2: "zu.",
			},

			upload: "Hochladen",
			value: "Wert",
			warning: "Achtung",
			filter: "Filter",
			clear: "Alle Filter zurücksetzen",
			close: "Schließen",
			rows: "Rows",
			columns: "Säulen",
			columnsShown: "Eingeblendete Säulen",
			export: "Export",
			next: "Next",
			previous: "Previous",
			addCriteria: "Add Criteria",
			copyCriteria: "Copy Criteria",
			archive: "Archive",
			unarchive: "Unarchive",
			"enter-your": "Geben Sie Ihr ",
			"not-support-tag": "Ihr Browser unterstützt dieses Tag nicht.",
			thumbnail: "Vorschaubild",
			"thumbnail-description":
				"Legen Sie eine Miniaturansicht fest, die die Aufmerksamkeit des Betrachters auf sich zieht",
			"trailer-video": "Trailer Video",
			"trailer-video-description":
				"Fügen Sie Ihr Video hinzu, das in der Schulung angezeigt werden soll",
			"large-image": "Großes Bild",
			"large-image-description": "Hinzufügen eines langen Bildes für ein Banner",
			"confirm-invite-description":
				"Um die Einladung zu bestätigen, geben Sie bitte Ihre Daten ein",
			"invitation-expired": "Die Einladung ist abgelaufen",
			"invitation-token-invalid": "Einladungs-Token ist ungültig",
			"invitation-already-accepted": "Die Einladung wurde bereits angenommen",
			"accepting-invitation": "Annahme der Einladung",
			"update-pass-description": "Bitte wählen Sie ein Passwort, das noch nicht verwendet wurde. ",
			"request-error": "Fehler anfordern",
			[Role.ADMIN]: "Admin",
			[Role.USER]: "User",
			[Role.GLOBAL_ADMIN]: "Global Admin",
			none: "Keine",
			"role-placeholder": "Rolle:",
			all: "Alle",
			custom: "Individuell",
		},
		"manage-to-dos": {
			"MEDIUM-explanation": "Die Aufgabe ist wichtig, aber nicht kritisch.",
			"HIGH-explanation": "Die Aufgabe ist kritisch und muss sofort erledigt werden.",
			"LOW-explanation": "Die Aufgabe ist wenig wichtig und kann später erledigt werden.",
			"select-all": "Alle auswählen",
			addAnswer: "Antwort hinzufügen",
			title: "To-Do-Elemente verwalten",
			subtitle: "To-Do-Elemente",
			[QuestionnaireImportance.IMPORTANT]: "Wichtig",
			[SORT_BY_ALL]: "Alle",
			"sort-by": "Sortieren nach",
			"filter-by": "Filtern nach",
			"form-fields": {
				title: "Maßnahmenname",
				category: "Kategorie",
				measureDescription: "Maßnahmenbeschreibung",
				measureRecommendation: "Maßnahmenempfehlung",
				description: "Beschreibung",
				recommendation: "Empfehlung",
				requirement: "Allgemeine Anforderungen",
				question: "Frage",
				"organization-type": "Organisationstyp",
				"showing-mode": "Modus hinzufügen",
				"out-of-date": "Veraltet",
				priority: "Priorität",
				definition: "Empfehlung",
				subTaskTitle: "Anforderung",
				subTaskInfo: "Zusatsinformation",
				"sub-tasks": "Zwischenschritte",
				"add-sub-task": "Unteraufgabe hinzufügen",
				"question-description": "Fragebeschreibung",
			},
			[ToDoPriority.LOW]: "Niedrig",
			[ToDoPriority.MEDIUM]: "Mittel",
			[ToDoPriority.HIGH]: "Hoch",
			"select-industries": "Sektoren",
			"select-industry": "Wähle einen Sektor",
			"select-company-balance": "Wähle eine Jahresbilanz",
			"select-company-balances": "Jahresbilanzen",
			"select-company-sizes": "Unternehmensgrößen",
			"select-company-size": "Unternehmensgröße auswählen",
			"select-company-revenues": "Unternehmensumsätze",
			"select-company-revenue": "Unternehmensumsatz auswählen",
			[ShowingMode.ALL]: "Alle Unternehmen",
			[ShowingMode.ONLY_NEW]: "Nur neue Unternehmen",
			[ShowingMode.OUT_OF_DATE]: "Veraltet",
			"about-this-task": "Über diese Aufgabe...",
			"enter-recommendation": "Empfehlung eingeben...",
			"delete-title": "Diese Aufgabe löschen?",
			"delete-description":
				'Sind Sie sicher, dass Sie die Aufgabe "{{taskTitle}}" löschen möchten?',
			"list-empty": "Liste ist leer",
		},
		"manage-questionnaire": {
			addAnswer: "Antwort hinzufügen",
			addQuestion: "Frage hinzufügen",
			title: "Bedarfsanalyse verwalten",
			questions: "Fragen",
			"add-details": "Fügen Sie Details hinzu...",
			"form-fields": {
				title: "Aufgabenname",
				description: "Beschreibung",
				"answer-number": "Antwort {{number}}",
			},
			"select-industries": "Sektoren",
			"select-industry": "wähle einen Sektor",
			"select-company-balance": "Wähle eine Jahresbilanz",
			"select-company-sizes": "Unternehmensgrößen",
			"select-company-size": "unternehmensgröße auswählen",
			"select-company-revenues": "Unternehmensumsätze",
			"select-company-revenue": "unternehmensumsatz auswählen",
			[QuestionnaireImportance.IMPORTANT]: "Wichtig",
			[QuestionnaireImportance.STOP]: "Ausschluss",
			[QuestionnaireImportance.NONE]: "Nichts",
			"delete-title": "Diese Frage löschen?",
			"delete-description": 'Sind Sie sicher, dass Sie die Frage "{{taskTitle}}" löschen möchten?',
			"move-to": "Verschiebe die Aufgabe auf Schritt {{stepNumber}}",
			"list-empty": "Die Frageliste ist leer",
		},
		"manage-industries": {
			title: "Sektoren verwalten",
			industries: "Sektoren",
			"form-fields": {
				name: "Sektornname",
			},
			"add-industry": "Sektor hinzufügen",
			"delete-title": "Sektor löschen?",
			"delete-description": 'Sind Sie sicher, dass Sie den Sektor "{{taskTitle}}" löschen möchten?',
			"list-empty": "Liste ist leer",
		},
		"manage-company-size": {
			title: "Unternehmensgrößen verwalten",
			"company-sizes": "Unternehmensgrößen",
			"form-fields": {
				value: "Größenwert",
			},
			"add-company-size": "Unternehmensgröße hinzufügen",
			"delete-title": "Diese Größe löschen?",
			"delete-description":
				"Sind Sie sicher, dass Sie die Unternehmensgröße „{{sizeValue}}“ löschen möchten?",
			"list-empty": "Liste ist leer",
		},
		"manage-company-revenue": {
			title: "Umsatz verwalten",
			"company-revenues": "Umsätze",
			"form-fields": {
				value: "Umsatzwert",
			},
			"add-company-revenue": "Umsatz hinzufügen",
			"delete-title": "Diesen Umsatz löschen?",
			"delete-description": "Möchten Sie den Umsatz „{{revenueValue}}“ wirklich löschen?",
			"list-empty": "Keine Einträge vorhanden",
		},
		"manage-company-balance": {
			title: "Jahresbilanz verwalten",
			"company-balances": "Jahresbilanzen",
			"form-fields": {
				value: "Jahresbilanzwert",
			},
			"add-company-balance": "Jahresbilanz hinzufügen",
			"delete-title": "Diese Jahresbilanz löschen?",
			"delete-description": "Möchten Sie die Jahresbilanz „{{balanceValue}}“ wirklich löschen?",
			"list-empty": "Keine Einträge vorhanden",
		},
		"manage-task-templates": {
			title: "Aufgabenvorlagen verwalten",
			"add-template": "Vorlage hinzufügen",
			"list-empty": "Noch keine Aufgabenvorlagen vorhanden.",
			"create-title": "Aufgabenvorlage erstellen",
			"create-subtitle":
				"Definieren Sie eine neue Aufgabenvorlage, die Unternehmen zugewiesen wird.",
			"edit-title": "Aufgabenvorlage bearbeiten",
			"edit-subtitle": "Aktualisieren Sie die Vorlagendetails und verwalten Sie Unteraufgaben.",
			"edit-subtask-title": "Unteraufgaben-Vorlage bearbeiten",
			"edit-subtask-subtitle": "Aktualisieren Sie die Details der Unteraufgaben-Vorlage.",
			create: "Erstellen",
			update: "Aktualisieren",
			"delete-title": "Diese Vorlage löschen?",
			"delete-description": 'Möchten Sie „{{title}}" wirklich löschen?',
			"delete-confirm": "Löschen",
			table: {
				title: "Titel",
				priority: "Priorität",
				order: "Reihenfolge",
				subtasks: "Unteraufgaben",
				actions: "Aktionen",
			},
			form: {
				title: "Titel",
				description: "Beschreibung",
				priority: "Priorität",
				complexity: "Komplexität",
				order: "Reihenfolge",
				subtasks: "Unteraufgaben-Vorlagen",
				"new-subtask-placeholder": "Neuer Unteraufgaben-Titel...",
			},
		},
		errorPages: {
			buttonText: "Zur Startseite",
			description:
				"Entweder haben Sie einen verdächtigen Weg probiert oder Sie sind versehentlich hierher gekommen. Egal was es ist, versuchen Sie es über die Navigation.",
			notFound: "404: Die Seite, die Sie suchen, ist hier nicht",
			serverError: "500: Interner Serverfehler",
			unauthorize: "401: Autorisierung erforderlich",
			forbidden: "403: Verboten",
		},
		forgotPassword: {
			forgotPasswordCta: "Link zum Zurücksetzen senden",
			submittedFeedbackMessage:
				"Überprüfen Sie Ihren Posteingang. Wir senden eine E-Mail mit Anweisungen, wie Sie Ihr Passwort zurücksetzen können!",
			title: "Passwort vergessen",
			description:
				"Bitte geben Sie Ihre registrierte E-Mail Adresse ein. Wir senden Ihnen dann einen Link zum Zurücksetzen.",
			send: "Senden",
			"back-to-login": "Zurück zur Anmeldung",
		},
		inviteUser: {
			button: "Neuen Nutzer einladen",
			modal: {
				cta: "Einladen",
				emailPlaceholder: "E-Mail eingeben",
				firstNamePlaceholder: "Vorname eingeben",
				lastNamePlaceholder: "Nachname eingeben",
				rolePlaceholder: "Rolle auswählen",
				title: "Benutzer einladen",
			},
		},
		login: {
			emailPlaceholder: "Ihre E-Mail-Adresse",
			forgotPasswordCta: "Passwort vergessen?",
			loginCta: "Anmelden",
			contactUsCta: "Kontakt",
			passwordPlaceholder: "Ihr Passwort",
			invalidData: "E-Mail oder Passwort falsch",
			title: "Willkommen zurück",
			description: "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
			"check-email": {
				title: "Prüfen Sie Ihre E-Mail",
				description: "Wir haben einen Verifizierungslink an ",
				"back-to-login": "Zurück zum Einloggen",
			},
			"remember-me": "Erinnern Sie sich an mich",
			noAccount: "Noch kein Konto?",
			registerCta: "Jetzt registrieren",
		},
		register: {
			title: "Konto erstellen",
			description: "Registrieren Sie sich, um Ihre NIS-2-Aufgaben zu verwalten.",
			registerCta: "Registrieren",
			haveAccount: "Bereits ein Konto? Jetzt anmelden",
		},
		"confirm-email": {
			title: "E-Mail-Bestätigung",
			description:
				"Bitte klicken Sie auf die Schaltfläche „Bestätigen“, wenn Sie Ihre Registrierung auf der NIS-2-Plattform bestätigen und zur Liste Ihrer Aufgaben weitergehen möchten.",
			confirm: "Bestätigen",
			"go-to-login": "Zum Login gehen",
			"company-successfully-confirmed":
				"Das Unternehmen wurde erfolgreich verifiziert. Sie können sich nun anmelden und die Empfehlungen zur Erreichung des NIS-2-Sicherheitsniveaus einsehen.",
		},
		modals: {
			addAvatar: {
				description: "<underline>Klicken zum Hochladen</underline> oder ziehen und ablegen",
				fileSize: "Maximale Dateigröße ist 3 MB",
				title: "Datei hochladen",
			},
			deleteRole: {
				title: "Rolle löschen",
			},
			deleteUser: {
				title: "Benutzer löschen",
				description:
					"Sind Sie sicher, dass Sie den Benutzer {{firstName}} {{lastName}} löschen möchten?",
			},
			editUser: {
				rolePlaceholder: "Rollen auswählen",
				title: "Benutzer bearbeiten",
				subtitle: "Aktualisieren Sie die Details nach Bedarf.",
			},
		},
		twoFA: {
			code: "Code",
			cta: "Bestätigen",
			title: "2FA-Code eingeben",
			description:
				"Bitte geben Sie den Verifizierungscode ein. Wir haben ihn an Ihre E-Mail gesendet.",
		},
		users: {
			title: "Benutzer",
			search: "Benutzer suchen",
		},
		userRoles: {
			title: "Rollen",
			button: "Benutzerrollen",
			modal: {
				create: {
					permissionPlaceholder: "Berechtigungen auswählen",
					title: "Rolle erstellen",
				},
				edit: {
					title: "Rolle aktualisieren",
				},
			},
			placeholders: {
				codePlaceholder: "Eingeben",
				namePlaceholder: "Name eingeben",
			},
		},
	},
};
